import React, { useRef, useEffect, useState } from 'react';
import riskReducer from '../../../store/reducers/riskReducer';
import { connect } from "react-redux";
import { compose } from "redux";
import { useTranslation } from "react-i18next";
import {
  LineChart, Line, ResponsiveContainer, LabelList
} from 'recharts';

const IncidentTrend = ({ height, data }) => {
  const { t } = useTranslation();
  // const data = [
  //   { name: 'Jan', value: 3 },
  //   { name: 'Feb', value: 5 },
  //   { name: 'Mar', value: 4 },
  //   { name: 'Apr', value: 7 },
  //   { name: 'May', value: 6 },
  // ];

  const [processedData, setprocessedData] = useState([]);
  const [latestValue, setlatestValue] = useState(0);
  useEffect(() => {
      if (data && data?.length) {
        setprocessedData(data)
        setlatestValue(data[data?.length - 1].value)
        //console.log("Raw data ", data)
        //console.log("Prcessed data ", processedData)
      } else if(data){
         setprocessedData(data)
         setlatestValue(0)
      }
      
    }, [data]);
  return (
    <div 
      className="w-full bg-white rounded-lg flex flex-col justify-center" 
      style={{ 
        height: typeof height === 'string' ? height : `${height}px`,
        minHeight: '100px',
        maxHeight: '150px',
        padding: 'min(12px, 2vh) min(8px, 2vw)'
      }}
    >
      <div 
        className="text-gray-800 mb-1"
        style={{ 
          fontSize: 'min(14px, 3.5vw)',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        {latestValue} {t("generalDashboard.incidents")}
      </div>

      <div className="flex-1 flex items-center justify-center" style={{ minHeight: '60px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={processedData}>
            <Line
              type="monotone"
              dataKey="value"
              stroke="#F07167"
              strokeWidth={2}
              dot={{ r: 2 }}
              isAnimationActive={false}
            >
              <LabelList 
                dataKey="value" 
                position="top" 
                offset={8} 
                style={{ fontSize: 'min(10px, 2.5vw)' }}
              />
            </Line>
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  //////console.log("Controls", state.dashboard.general_dashboard_data.type_controls)
    return {

        //token: state.auth.token,
        //departments: state.department.departments,
        //department_id: state.department.department_id
        data:  state.dashboard.general_dashboard_data.incident_details
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(IncidentTrend);